import {Injectable, OnDestroy} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {NotificationType} from '../enum';
import {LoginTranslationsService} from 'src/app/shared/translations';
import {AuthenticatedUser} from '../models';
import {DefaultNotificationService, StorageService} from '../services';

/**
 * Checks whether the user has permission to access the customer merge process.
 */
@UntilDestroy()
@Injectable()
export class CustomerMergeGuard implements OnDestroy {
  private authenticatedUser?: AuthenticatedUser;

  constructor(
    private storage: StorageService,
    private router: Router,
    private notificationService: DefaultNotificationService,
    private loginTranslationsService: LoginTranslationsService
  ) {
    this.storage.castAuthenticatedUser.pipe(untilDestroyed(this))
      .subscribe((user: AuthenticatedUser) => user !== null ? this.authenticatedUser = user : null);
  }

  public ngOnDestroy(): void {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authenticatedUser !== null) {
      const user = this.authenticatedUser;
      // check if user has the right permission
      if (user.isAdminType || user.isTicketAgent) {
        // permission is there so we return true
        return true;
      }
      this.notificationService.showNotification({
        type: NotificationType.WARNING,
        message: this.loginTranslationsService.i18nErrorNoAccess,
      });
    }
    this.router.navigate([`/club/${route.parent.paramMap.get('id')}`]);
    return false;
  }
}
